"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.useModal = exports.ModalProvider = exports.ModalContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _framerMotion = require("framer-motion");

var _ri = require("react-icons/ri");

var _view = require("../view");

var _card = require("../card");

var _text = require("../text");

var _button = require("../button");

var _spacer = require("../spacer");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // import { Break } from '../break'


var ModalContext = /*#__PURE__*/(0, _react.createContext)({});
exports.ModalContext = ModalContext;

var ModalProvider = function ModalProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      modal = _useState2[0],
      setModal = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var closeModal = function closeModal() {
    setIsOpen(false);
    setTimeout(function () {
      modal && modal.onClose && modal.onClose();
      setModal(null);
    }, 500);
  };

  (0, _react.useEffect)(function () {
    if (modal) {
      setIsOpen(true);
    }
  }, [modal]);

  var context = _objectSpread(_objectSpread({}, modal), {}, {
    isOpen: isOpen,
    setModal: setModal,
    closeModal: closeModal
  });

  return /*#__PURE__*/_react["default"].createElement(ModalContext.Provider, {
    value: context
  }, children);
};

exports.ModalProvider = ModalProvider;

var useModal = function useModal() {
  return (0, _react.useContext)(ModalContext);
};

exports.useModal = useModal;

var Modal = function Modal() {
  var _useModal = useModal(),
      component = _useModal.component,
      title = _useModal.title,
      isOpen = _useModal.isOpen,
      closeModal = _useModal.closeModal;

  return /*#__PURE__*/_react["default"].createElement(_view.View, {
    extend: rootCSS({
      isOpen: isOpen
    })
  }, /*#__PURE__*/_react["default"].createElement(_view.View, {
    extend: backdropCSS,
    as: _framerMotion.motion.div,
    animate: {
      opacity: isOpen ? 1 : 0
    },
    initial: false,
    onClick: function onClick() {
      return closeModal();
    }
  }), /*#__PURE__*/_react["default"].createElement(_card.Card, {
    extend: modalCSS,
    as: _framerMotion.motion.div,
    initial: false,
    animate: {
      opacity: isOpen ? 1 : 0,
      transform: "translateY(".concat(isOpen ? 0 : 30, "vh) scale(").concat(isOpen ? 1 : 0.7, ")")
    },
    transition: {
      duration: 0.2
    }
  }, /*#__PURE__*/_react["default"].createElement(_view.View, {
    extend: titleCSS
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    variant: "large"
  }, title), /*#__PURE__*/_react["default"].createElement(_button.Button, {
    subVariant: "icon",
    empty: true,
    onClick: closeModal
  }, /*#__PURE__*/_react["default"].createElement(_ri.RiCloseLine, {
    size: 24
  }))), /*#__PURE__*/_react["default"].createElement(_spacer.Spacer, null), /*#__PURE__*/_react["default"].createElement(_spacer.Spacer, {
    size: 2
  }), /*#__PURE__*/_react["default"].createElement(_view.View, {
    extend: contentCSS
  }, component)));
};

exports.Modal = Modal;

var rootCSS = function rootCSS(_ref2) {
  var isOpen = _ref2.isOpen;
  return function (_ref3) {
    var grid = _ref3.theme.grid;
    return {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 5,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 2 * grid,
      pointerEvents: isOpen ? 'auto' : 'none'
    };
  };
};

var backdropCSS = function backdropCSS() {
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.5)',
    backdropFilter: 'blur(2px)'
  };
};

var modalCSS = function modalCSS(_ref4) {
  var _ref4$theme = _ref4.theme,
      breakpoints = _ref4$theme.breakpoints,
      grid = _ref4$theme.grid;
  return _defineProperty({
    width: '100%',
    maxWidth: 700,
    overflow: 'hidden',
    maxHeight: '100%'
  }, breakpoints.onlyS, {
    padding: 2 * grid
  });
};

var titleCSS = {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
};
var contentCSS = {
  width: '100%',
  overflowY: 'scroll',
  maxHeight: '80vh'
};